import React, {HTMLInputTypeAttribute, useState} from "react";
import styled from "styled-components";
import {Primitive} from "../../../../../Types";

interface PropsI {
    value: string,
    onChange: (arg: Primitive, invalid?: boolean) => void,
    name: string,
}

export default function RawEditNumberInput({value, onChange, name}: PropsI) {

    let [newValue, setNewValue] = useState<string>(value === null ? '0' : value)
    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewValue(e.currentTarget.value);
    };

    const onBlur = () => {
        const parsedValue = parseFloat(newValue);
        onChange(parsedValue, isNaN(parsedValue))
    }

    return <TextInput name={"edit-" + name} id={"edit-" + name}
                      type={"number"}
                      value={newValue}
                      onBlur={onBlur}
                      onChange={onChangeHandler}></TextInput>

}

const TextInput = styled.input`
    text-indent: 2px;
    font-size: 1rem;
`
